export const landingPage = {
  backgroundUrl: "/backgrounds/bg_art_train.jpg",
  hero: {
    title: "Free Anuel",
    text: "La plataforma de Esports más competitiva de América Latina",
    sectionNavTitle: "Inicio",
    image: "/icons/landing-lobby.png",
    benefits: [
      {
        icon: "/icons/services.png",
        text: "Realizado con mucha pasión con un equipo de desarrollo en el Perú",
      },
      {
        icon: "/icons/server.png",
        text: "Datacenter 100% propio alojado en el Perú y operando desde el año 2017",
      },
      {
        icon: "/icons/trophy.png",
        text: "Invirtiendo en Equipos y Eventos regionales desde el año 2019",
      },
    ],
  },
  sections: [
    {
      subtitle: "Juega",
      sectionNavTitle: "Competitivo",
      sectionClassName: "competitive",
      title: "Competitivo",
      image: "/icons/landing-competitive.png",
      text: "Disfruta con total fluidez de tus partidas en servidores de gama alta y no te pierdas ninguna jugada importante",
      orientation: "reverse",
      aditionalInfo: [
        {
          iconUrl: "/icons/server.png",
          text: "Mejora tu experiencia de CS:GO en todo América Latina con menor latencia",
          title: "Servidores",
        },
        {
          iconUrl: "/icons/services.png",
          text: "Juegos equilibrados en los servidores de juegos de la más alta calidad de todo el mundo.",
          title: "Balance",
        },
      ],
    },
    {
      subtitle: "Mejora tus",
      sectionNavTitle: "Estadísticas",
      sectionClassName: "statictics",
      image: "/icons/landing-stats.png",
      title: "Estadísticas",
      text: "Nuestro motor de estadísticas actualizado te ayuda a seguir mejorando tu habilidad, controlar su progreso, subir de rango y asciender en tus tablas de clasificación regionales.",
      orientation: "reverse",
      aditionalInfo: [
        {
          iconUrl: "/icons/statistics.svg",
          text: "Estadísticas en tiempo real sobre tu evolución como deportista competitivo",
          title: "Tiempo Real",
        },
        {
          iconUrl: "/icons/mobile_statistics.svg",
          text: "Encuentra tus estadísticas no solo en la web, ¡Pronto lo tendrás en tu celular!",
          title: "Web y Móvil",
        },
      ],
    },
    {
      subtitle: "Participa en",
      sectionNavTitle: "Torneos",
      sectionClassName: "tournaments",
      image: "/icons/landing-tournament.png",
      title: "Torneos",
      text: "El sistema de ligas ha sido rediseñado para dar a todos los jugadores la oportunidad de ascender a la cima de la clasificación, aumentar su nivel, y ganar premios incluso cuando juegan en ligas gratis.",
      aditionalInfo: [
        {
          iconUrl: "/icons/secure-shield.png",
          text: "Juega contra los jugadores más competitivos sin preocuparte por los tramposos",
          title: "Protección",
        },
        {
          iconUrl: "/icons/time.svg",
          text: "Torneos y eventos todos los meses, durante los 365 días del año sin parar. ¿Te atreves?",
          title: "Sin Parar",
        },
      ],
    },
    {
      subtitle: "Gana",
      sectionNavTitle: "Premios",
      sectionClassName: "prizes",
      title: "Premios",
      image: "/icons/landing-prizes.png",
      text: "Gana importantes premios virtuales como físicos, asi como tambien un puesto en el ranking competitivo",
      orientation: "reverse",
      aditionalInfo: [
        {
          iconUrl: "/icons/prizes.svg",
          text: "Cada vez más y mejores premios para los participantes con membresías activas",
          title: "Solo VIP",
        },
        {
          iconUrl: "/icons/money.svg",
          text: "Nunca antes ganar dinero haciendo lo que te gusta fue tan facil, ¿Verdad?",
          title: "Dinero",
        },
      ],
    },
  ],
};
